/* eslint-disable */
<template>
  <div class="add_template" @click="handtipshow">
    <div>
      <!-- 任务input -->
      <div class="task_box">
        <div>消息标题：</div>
        <el-input v-model="taskinput" style="width:400px" placeholder="用于内部区分消息，不影响消息内容" />
      </div>
      <div class="choose_plate" style="margin-top:10px">
        <div class="choose_text">选择平台：</div>
        <el-select v-model="textpalateid" class="add_name" placeholder="请选择平台" :disabled="ontype == 3" @change="changetextpalate">
          <el-option
            v-for="items in plateoption"
            :key="items.id"
            :label="items.name"
            :value="items.id"
          />
        </el-select>
      </div>
      <div style="color:red;margin-top:10px">*更换平台会清空之前所填写的文本和链接</div>
      <!-- <div class="choose_plate" style="margin-top:10px">
        <div class="choose_text">选择活动：</div>
        <el-tag v-if="activityid!=null" style="margin-right:10px">{{ activityidname }}</el-tag>
        <el-button type="primary" size="mini" :disabled="textpalateid===''" @click="chooseactivity">选择活动</el-button>
      </div> -->

      <div class="tab_box">
        <el-tabs v-model="activeName">
          <el-tab-pane v-for="item,index in tabarr" :key="index" :label="item.value" :name="item.key">
            <div v-if="item.key === 'text'">
              <!-- tab文字 -->

              <!-- <tinymce-editor
            v-if="showtinymce"
            ref="editor"
            v-model="obj.content"
            :disabled="disabled"
            :base-url="baseUrl"
            :language="language"
            :skin="skin"
            :updata="updata"
            @onClick="onClick"
          /> -->
              <el-input
                v-model="obj.content"
                type="textarea"
                :rows="8"
                placeholder="请输入内容"
                @blur="handleInputBlur"
              />
              <!-- 文本选择功能区 -->
              <div class="choose_textr">
                <el-popover
                  placement="right"
                  width="400"
                  trigger="click"
                >
                  <div style="display:flex;flex-wrap:wrap">
                    <div v-for="(itemr,indexr) in emoji_icon" :key="indexr" @click="itemclaickw(indexr)">
                      {{ itemr }}
                    </div>
                  </div>
                  <i slot="reference" class="el-icon-info" />
                </el-popover>
                <el-link type="primary" class="link_url" @click="linkclick">超链接</el-link>
                <el-link type="primary" @click="keyworddialogVisible = true">关键词</el-link>
                <el-link type="primary" class="link_url" @click="appletclick">小程序</el-link>
              </div>
              <!-- <div class="choose_plate">
                <div class="choose_text">平台：</div>
                <el-select v-model="textpalateid" class="add_name" placeholder="请选择平台" @change="changetextpalate">
                  <el-option
                    v-for="items in plateoption"
                    :key="items.id"
                    :label="items.name"
                    :value="items.id"
                  />
                </el-select>
              </div> -->
              <div style="margin-top:20px">
                <el-select v-model="addtifit" :disabled="textpalateid===''" filterable placeholder="添加标志" class="add_name">
                  <el-option
                    v-for="items in options"
                    :key="items.key"
                    :label="items.value"
                    :value="items.key"
                  />
                </el-select>
                <el-link type="primary" @click="addidentifit">添加标志</el-link>
              </div>
            </div>
            <div v-if="item.key === 'img'">
              <!-- tab切换图片 -->

              <img v-if="temporary" class="pic_img" :src="temporary">
              <div>
                <el-button type="primary" size="mini" @click="materiallibrary">  {{ temporary === null ? '素材库选择/上传' : '素材库修改/上传' }}</el-button>
                <!-- <el-button type="primary" size="mini" @click="$refs.file[0].click()">{{ temporary === null ? '本地上传' : '本地修改' }}<input ref="file" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change="uploadPictures"></el-button> -->
              </div>

            </div>
            <div v-if="item.key === 'news'">

              <!-- tab图文链接 -->

              <!-- <div>导入：  <el-button type="primary" size="mini">历史图文链接</el-button></div> -->

              <div class="allexamples_box">
                <div v-if="arr.length === 1" class="examples_leftbox">
                  <div class="within_box">
                    <div class="title_boxr">{{ arr[0].title }}</div>
                    <div class="imaetext se_top">
                      <div class="describe_text" style="width:156px">{{ arr[0].description }}</div>
                      <div>
                        <img v-if="arr[0].testsrc" style="width:50px;height:50px;object-fit: contain;" :src="arr[0].testsrc">
                      </div>
                    </div>
                  </div>
                  <div class="addwr" @click="addImageText">+新建消息</div>
                </div>
                <div v-else style="margin-right:20px">
                  <div v-for="items,indexr in arr" :key="indexr" :class="[items.id===active?'updataactive':'',indexr === 0 ? 'updatabox' : 'updatabox1']" @click.stop="activeclick(items.id,indexr)">
                    <span :class="[indexr === 0?'spanbox':'spanbox1']">
                      {{ items.title }}
                    </span>
                    <div :style="{backgroundImage: 'url('+items.testsrc+')'}" :class="[indexr === 0?'backrbox':'backrbox1']" />
                    <div v-show="items.showtips && indexr !== 0" class="ciclebox">
                      <div class="tiparrowbox">
                        <!-- 删除 -->
                        <i v-show="indexr !== 0" class="el-icon-delete tipicon" @click.stop="deleteitem(indexr)" />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="arr.length<8"
                    class="addbox"
                  >
                    <span @click="addImageText">+新建消息</span>
                  </div>
                </div>

                <div class="examples_rightbox">
                  <div class="input_box"><div>标题：</div><div><el-input v-model="arr[indexinput].title" maxlength="50" style="width:420px" placeholder="请输入标题" @blur="tiaoInputBlur" /></div> </div>
                  <el-select v-model="addbiaoright" :disabled="textpalateid===''" filterable placeholder="添加标志" style="margin:0px 10px 20px 42px">
                    <el-option
                      v-for="items in options"
                      :key="items.key"
                      :label="items.value"
                      :value="items.key"
                    />
                  </el-select>

                  <el-link type="primary" @click="addwebpagebox">添加标志</el-link>
                  <div v-if="arr[indexinput].switchvalue!=1" class="input_box">
                    <div>链接：</div>
                    <div><el-input v-model="arr[indexinput].url" style="width:420px" placeholder="请输入链接" /></div>
                  </div>
                  <div class="choosecover" style="margin-bottom:10px">
                    <div class="text_wei">
                      添加链接：
                    </div>
                    <!-- <el-tag @click="addbookactivey">添加书城活动</el-tag> -->
                    <div @click="beforehandleCommand">
                      <el-dropdown trigger="click" @command="handleCommand">
                        <!-- <span class="el-dropdown-link" style="cursor: pointer;"> -->
                        <el-button type="primary" size="mini" :disabled="linkallarr.length == 0">
                          选择h5/小程序链接<i class="el-icon-arrow-down el-icon--right" />
                        </el-button>
                        <!-- </span> -->
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-for="(items,indexr) in linkallarr" :key="indexr" :command="beforeHandleCommand(items.sign,items.identification)">{{ items.type_name }}</el-dropdown-item>
                        <!-- <el-dropdown-item command="a">添加书城活动</el-dropdown-item>
                        <el-dropdown-item command="b">添加红包活动</el-dropdown-item>
                        <el-dropdown-item command="c">添加书城链接活动</el-dropdown-item> -->
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <div v-if="ontype == 3" style="color:red;margin-left:15px">*变更消息链接时，将会对所关联的策略进行重新绑定</div>
                  </div>
                  <!-- <div class="choose_plate" style="margin-bottom:10px">
                    <div class="choose_text">平台：</div>
                    <el-select v-model="palateid" placeholder="请选择平台" @change="changepalate">
                      <el-option
                        v-for="items in plateoption"
                        :key="items.id"
                        :label="items.name"
                        :value="items.id"
                      />
                    </el-select>
                  </div> -->

                  <div class="task_box seser" style="margin-bottom:20px">
                    <div class="tewr_text">h5跳小程序：</div>
                    <el-switch
                      v-model="arr[indexinput].switchvalue"
                      style="display: block"
                      :active-value="1"
                      :inactive-value="2"
                      active-text="开"
                      inactive-text="关"
                      @change="htiaower"
                    />
                  </div>
                  <div v-if="arr[indexinput].switchvalue == 1" class="task_box seser">
                    <div class="tewr_text">appid：</div>
                    <el-input v-model="arr[indexinput].app_ids" :disabled="arr[indexinput].moswitchvalue == 1" style="width:300px" placeholder="小程序appid（小程序务必授权在运营系统）" @blur="removeAllSpaces" />
                    <el-switch
                      v-model="arr[indexinput].moswitchvalue"
                      style="display: block;margin-left:10px"
                      :active-value="1"
                      :inactive-value="2"
                      active-text="默认"
                      inactive-text="不默认"
                      @change="mochange"
                    />
                  </div>
                  <div v-if="arr[indexinput].switchvalue == 1" class="task_box seser" style="margin-bottom:20px">
                    <div class="tewr_text">链接：</div>
                    <el-input v-model="arr[indexinput].app_path" style="width:400px" placeholder="小程序跳转路径path" @blur="removeAllSpacestwo" />
                  </div>

                  <div class="input_box"><div>描述：</div> <div><el-input v-model="arr[indexinput].description" maxlength="50" style="width:300px" type="textarea" placeholder="请输入描述" /></div></div>
                  <div class="cover_box">
                    <div>封面：</div>
                    <!-- <el-upload
                      class="upload-demo"
                      drag
                      action=""
                      :auto-upload="false"
                      :show-file-list="false"
                      :on-change="changeUpload"
                    >
                      <div class="choosecover">
                        <div class="choose_cover">{{ arr[indexinput].testsrc === '' ? '选择封面' : '修改封面' }}</div>
                      </div>
                    </el-upload>Ï -->
                    <!-- <el-button type="primary" size="mini" @click="$refs.filerrr[0].click()">上传封面<input ref="filerrr" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change="changeUpload"></el-button> -->
                    <el-button type="primary" size="mini" @click="materiallibrary">{{ arr[indexinput].testsrc === '' ? '素材库选择/上传' : '素材库修改/上传' }}</el-button>
                  </div>
                  <div style="color:red;margin-top:10px">*图片链接，支持JPG、PNG格式，较好的效果为大图360*200，小图200*200</div>
                  <img v-if="arr[indexinput].testsrc" :src="arr[indexinput].testsrc" class="uopatatextimg">

                </div>
              </div>
            </div>
            <div v-if="item.key == 'miniprogrampage'">
              <div style="margin-top:20px">
                <el-form :label-position="labelPosition" label-width="90px" :model="formLabelAlign">
                  <el-form-item label="标题">
                    <el-input v-model="formLabelAlign.name" style="width:200px" />
                  </el-form-item>
                  <el-form-item label="上传封面">
                    <div>
                      <img v-if="programimg" class="li_img" :src="programimg">
                    </div>
                    <el-button type="primary" size="mini" @click="materiallibrary">素材库选择/上传</el-button>
                    <!-- <el-button type="primary" size="mini" @click="$refs.filerr[0].click()">上传封面<input ref="filerr" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change="uploadPicturesr"></el-button> -->
                  </el-form-item>
                  <el-form-item label="小程序类型">
                    <el-select v-model="formLabelAlign.appid" placeholder="请选择" @change="chawer">
                      <el-option
                        v-for="items in programtype"
                        :key="items.mini_program_type"
                        :label="items.type_name"
                        :value="items.mini_program_type"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="formLabelAlign.appid===99" label="appId">
                    <el-input v-model="formLabelAlign.appid_Link" style="width:200px" />
                  </el-form-item>
                  <el-form-item label="跳转地址">
                    <el-input v-model="formLabelAlign.link" style="width:200px" />
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div v-if="item.key == 'miniprogram_official'">
              <div><el-button type="primary" size="mini" @click="chooseofficial">选择官方小程序</el-button></div>
              <div class="chooser_allbox">
                <div v-for="(official, officialIndex) in selectOffical" :key="officialIndex" class="serwerwe">
                  <div class="Pchooser_allbox">
                    <img v-if="official.weappiconurl" :src="official.weappiconurl" alt="" style="width:30px;border-radius: 50%;">
                    <img v-else src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" style="width:30px;border-radius: 50%;">
                    <div class="Ptitlew_box">{{ official.des_1 }}</div>
                  </div>
                  <div class="Pdaserr">{{ official.title }}</div>
                  <div class="Pcahrw_box">
                    <img :src="official.thumburl" alt="" style="width:100%;height: 158px;">
                  </div>
                  <div class="Pline" />
                  <!-- <div style="color:#252525;margin-top: 5px;">
                    <span style="font-size: 15px;display: flex;align-items: center;flex-wrap: wrap;margin-bottom: 10px;">
                      <el-avatar :size="15" :src="item.sender_avatar" @error="errorHandler">
                        <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png">
                      </el-avatar><el-tag v-if="item.sender!=''" style="margin-left: 10px;"> {{ item.sender }}</el-tag>
                      <div v-else style="margin-left: 10px;width: 70px;height: 27px;" />
                    </span>
                    <div style="margin-bottom: 10px;">
                      <el-tag type="warning">{{ item.type_text }}</el-tag>
                    </div>
                    <div style="display: flex;">
                      <el-tag> {{ item.created_at_str }}</el-tag>
                    </div>
                    <div style="font-size: 12px;margin-top: 10px;" class="copy_box">
                      <el-tag v-if="item.miniprogram_no!=''" type="success">{{ item.miniprogram_no }}</el-tag>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 添加 -->

      <!-- <div class="add_boxr" @click="add">
        +添加
      </div> -->

      <div class="save_box">
        <el-button size="mini" type="primary" :disabled="disabledsave" @click="add">保存</el-button>
      </div>
    </div>
    <!-- 手机展示样式 -->
    <div class="phone_box">
      <div class="phone_content">
        <div v-if="activeName === 'text'" class="writtenwords" v-html="obj.content" />
        <div v-if="activeName === 'img'">
          <img v-if="temporary" class="pic_img" :src="temporary">
        </div>
      </div>
      <!-- 图文 -->
      <div class="phone_contentone">
        <div v-if="activeName === 'news'" class="newview">
          <div v-if="arr.length === 1" class="examples_leftboxtelrp">
            <div class="within_box">
              <div class="title_boxr" style="width:157px">{{ arr[0].title }}</div>
              <div class="imaetext se_top">
                <div class="describe_text">{{ arr[0].description }}</div>
                <div>
                  <img v-if="arr[0].testsrc" style="width:50px;height:50px;object-fit: contain;" :src="arr[0].testsrc">
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div v-for="items,indexr in arr" :key="indexr" style="width: 204px;!important" :class="[indexr === 0 ? 'updatabox' : 'updatabox1']">
              <span :class="[indexr === 0?'spanbox':'spanbox1']">
                {{ items.title }}
              </span>
              <div :style="{backgroundImage: 'url('+items.testsrc+')'}" :class="[indexr === 0?'backrbox':'backrbox1']" />
            </div>
          </div>
        </div>
      </div>
      <!-- 小程序 -->
      <div class="phone_contentone">
        <div v-if="activeName === 'miniprogrampage'" class="imagetext">
          <div v-if="funame!=-1" class="image_title">{{ programtype[funame].type_name }}</div>
          <div class="image_title">{{ formLabelAlign.name }}</div>

          <!-- <div v-if="funame.type_name" class="image_title">{{ funame.type_name }}</div>
          {{ funame }} -->
          <div class="imaetext">
            <img v-if="programimg" style="width:50px;height:50px;object-fit: contain;" :src="programimg">
          </div>
        </div>
      </div>
      <!-- 官方小程序 -->
      <div class="phone_contentone">
        <div v-if="activeName === 'miniprogram_official'" class="imagetext">
          <div v-for="item,index in selectOffical" :key="index" class="Pchooser_box">
            <div class="Pchooser_allbox">
              <img v-if="item.weappiconurl!='' && item.weappiconurl!=null" :src="item.weappiconurl" alt="" srcset="" style="width:30px;border-radius: 50%;">
              <img v-else src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" style="width:30px;border-radius: 50%;">
              <!-- <div class="titlew_box">{{ item.title }}</div> -->
              <div class="Ptitlew_box">{{ item.des_1 }}</div>
            </div>
            <div class="Pdaser">{{ item.title }}</div>
            <div class="Pcahrw_box">
              <img :src="item.thumburl" alt="" srcset="" style="width:100%;height: 158px;">
            </div>
            <div style="margin:6px 0px">{{ item.remark }}</div>
            <div>{{ item.created_at_str }}</div>
            <div class="Pline" />
            <!-- <div style="color:#252525;margin-top: 5px;">
              <span style="font-size: 15px;display: flex;align-items: center;flex-wrap: wrap;margin-bottom: 10px;">
                <el-avatar :size="15" :src="item.sender_avatar" @error="errorHandler">
                  <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png">
                </el-avatar><el-tag v-if="item.sender!=''" style="margin-left: 10px;"> {{ item.sender }}</el-tag>
                <div v-else style="margin-left: 10px;width: 70px;height: 27px;" />
              </span>
              <div style="margin-bottom: 10px;">
                <el-tag type="warning">{{ item.type_text }}</el-tag>
              </div>
              <div style="display: flex;">
                <el-tag> {{ item.created_at_str }}</el-tag>
              </div>
              <div style="font-size: 12px;margin-top: 10px;" class="copy_box">
                <el-tag v-if="item.miniprogram_no!=''" type="success">{{ item.miniprogram_no }}</el-tag>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- vueCropper 剪裁图片实现 弹窗-->
    <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :info="true"
            :full="option.full"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :fixed="option.fixed"
            :center-box="option.centerBox"
            :info-true="option.infoTrue"
            :fixed-box="option.fixedBox"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :fixed-number="option.fixedNumber"
            :enlarge="option.enlarge"
            :mode="option.mode"
          />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="finish">确认</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 超链接弹窗 -->
    <el-dialog title="超链接" :visible.sync="linkdialogVisible" append-to-body :destroy-on-close="true">
      <Linkdialog ref="linkdialog" @linkbtn="linkbtn" />
    </el-dialog>
    <!-- 关键词弹窗 -->
    <el-dialog title="关键词" :visible.sync="keyworddialogVisible" append-to-body>
      <Keywordialog @keywordbtn="keywordbtn" />
    </el-dialog>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletwo"
      append-to-body
    >
      <chooseimg ref="mychild" @clickicon="clickicon" />
    </el-dialog>
    <!-- 选择活动 -->
    <el-dialog title="选择活动" :visible.sync="activitydialogVisible" append-to-body>
      <activity ref="activitybox" @close="activityclose" />
    </el-dialog>
    <!-- 书城活动列表 -->
    <el-dialog title="选择活动" :visible.sync="bookctyactivitiesVisible" append-to-body>
      <bookctyactivities ref="bookctyactivitiesbox" @callbadwr="callbadwr" />
    </el-dialog>
    <!-- 发红包活动列表 -->
    <el-dialog title="选择红包" :visible.sync="redbao" append-to-body>
      <reddialog ref="chooseredbao" @redcallback="redcallback" />
    </el-dialog>
    <!-- 书城链接活动 -->
    <el-dialog title="选择书城链接" :visible.sync="sclink" append-to-body>
      <booklinkdialog ref="sclinkview" @sclinkcallback="sclinkcallback" />
    </el-dialog>
    <!-- 小程序 -->
    <el-dialog title="选择小程序" :visible.sync="applets" append-to-body :destroy-on-close="true">
      <Appletsdialog ref="appletsview" @appletscallback="appletscallback" />
    </el-dialog>
    <!-- 官方小程序 -->
    <el-dialog title="选择小程序" :visible.sync="officialapplets" append-to-body :destroy-on-close="true">
      <chooseminofficial ref="chooseminofficialview" @chooseminofficialcallback="chooseminofficialcallback" />
    </el-dialog>
  </div>
</template>

<script>
// import draggable from 'vuedraggable'
import { qiniuToken } from '@/api/qiniuToken.js'
import { customerlogo, customermessagelist, customerservicecreat, newMaterial, mptypeslist, getlinktypeslist, customerMessageupdate } from '@/api/sourceMaterial.js'
import { miniprogramList } from '@/api/messageTemplate.js'
import * as qiniu from 'qiniu-js'
import emojiicon from '../js/expression.js'
import Linkdialog from './Linkdialog.vue'
import Keywordialog from './Keywordialog.vue'
// import chooseimg from '../../menumanagement/components/chooseimg.vue'
import chooseimg from '../../menumanagement/components/TencentCloudChooseimg.vue'
import activity from './Activity'
import bookctyactivities from './bookctyactivities'
import reddialog from './reddialog'
import booklinkdialog from './booklinkdialog.vue'
import Appletsdialog from './Appletsdialog.vue'
import getNowDate from '@/utils/mixins/convertToHump.js'
// import TinymceEditor from '@/components/tinymce-editor/tinymce-editor'
// import PaginationRight from '@/components/PaginationRight/index.vue'
import chooseminofficial from './chooseminofficial.vue'
export default {
  components: {
    /* TinymceEditor*/
    Linkdialog,
    Keywordialog,
    chooseimg,
    activity,
    bookctyactivities,
    reddialog,
    booklinkdialog,
    Appletsdialog,
    // PaginationRight,
    chooseminofficial
    /* draggable*/
  },
  mixins: [getNowDate],
  props: {
    plateoption: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      messageload: false,
      disabledsave: false,
      showtinymce: false, // 富文本显示隐藏
      activeName: 'text', // tab切换显示隐藏
      taskinput: '', // 任务名
      msgData: {},
      token: null, // 七牛云token
      temporary: null, // 上传图片显示(不是图文图片)
      keyid: null, // 上传图片成功的key 不是图文 是图片消息
      // 文本域获取富文本绑定
      obj: {
        content: ''
      },
      // 富文本配置
      updata: false,
      disabled: false,
      baseUrl: './',
      language: 'zh_CN',
      skin: 'oxide',
      // 表情数组
      emoji_icon: emojiicon.emoji_icon,
      // 图文绑定的参数
      title: '', // 图文题目
      url: '', // 图文地址
      describetion: '', // 图文描述
      testsrc: '', // 图文照片
      // 裁剪配置
      dialogVisible: false, // 图文弹窗
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        // outputType: 'jpeg', // 裁剪生成图片的格式     :output-type="option.outputType"
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 204, // 默认生成截图框宽度
        autoCropHeight: 204, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: false, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        enlarge: 1, // 图片根据截图框输出比例倍数
        mode: 'contain' // 图片默认渲染方式  contain , cover, 100px, 100% auto
      },
      // 防止重复提交
      loading: false,
      //  超链接弹窗
      linkdialogVisible: false,
      //  关键词弹窗
      keyworddialogVisible: false,
      options: [], // 标志数组

      optionsr: [],
      addtifit: '', // 标志绑定

      tabarr: [], // 客服消息状态列表 文本 图片 图文链接

      dialogVisibletwo: false, // 素材库弹窗

      blurIndex: null, // 获取输入框索引值

      tiaoblurIndex: null, // 获取输入框索引值

      addbiaoright: null,

      palateid: '',
      textpalateid: '',

      activityid: null, // 活动id
      activityidname: '', // 活动名称

      activitydialogVisible: false,
      bookctyactivitiesVisible: false,
      redbao: false,

      // 小程序消息参数
      labelPosition: 'right',
      formLabelAlign: {
        name: '',
        sourceMaterialId: null,
        link: '',
        appid: null,
        appid_Link: ''
      },
      programimg: null,
      programtype: [],
      sclink: false,
      linkallarr: [],
      applets: false,
      arr: [
        {
          id: Math.random(), // id
          title: '标题',
          url: '',
          description: '',
          testsrc: '',
          showtips: false, // tip框的显示隐藏
          switchvalue: 2, // 1开 2关
          app_ids: '', // 小程序
          app_path: '', // 链接
          moswitchvalue: 1 // 1 默认 2 不默认（前端储存）
        }
      ],
      active: null, // 选中那一项id
      indexinput: null, // 取出来的索引值
      arrsw: [],
      tableData: [], // 官方小程序列表
      selectOffical: [], // 选择的官方小程序内容
      total: null,
      query: {
        page: 1,
        page_size: 10,
        type: 3,
        onlyMe: null
      },
      officialapplets: false,
      storagetype: 9,
      ontype: null,
      customer_message_no: null,
      apiUrl: process.env.VUE_APP_BACKUP_API_URL.replace('api', '')
    }
  },
  computed: {
    funame: function() {
      // eslint-disable-next-line eqeqeq
      return this.programtype.findIndex(v => v.id == this.formLabelAlign.appid)
    }
  },
  beforeDestroy() {
    if (window.JSON.parse(window.localStorage.getItem('customerServiceFatherTypeStorage') || 0) === 8) {
      console.log('beforeDestroy')
      if (!this.messageload) {
        const data = {
          taskinput: this.taskinput,
          textpalateid: this.textpalateid,
          obj: this.obj.content,
          addtifit: this.addtifit,
          arr: this.arr,
          addbiaoright: this.addbiaoright,
          activeName: this.activeName,
          formLabelAlign: this.formLabelAlign,
          selectOffical: this.selectOffical,
          temporary: this.temporary,
          programimg: this.programimg,
          emoji_icon: this.emoji_icon
        }
        window.localStorage.setItem('customerServiceMassageStorage', JSON.stringify(data))
      } else {
        window.localStorage.removeItem('customerServiceMassageStorage')
        window.localStorage.removeItem('customerServiceTypeStorage')
        // window.localStorage.removeItem('customerServiceFatherTypeStorage')
      }
    }
  },
  created() {
    // 获取七牛云
    this.getQiniuToken()
    // 获取客服消息标识
    // this.getcustomercation()
    // 客服消息类型列表
    this.customerlist()
    // 获取小程序消息类型
    this.getmptypeslist()
    this.active = this.arr[0].id
    this.indexinput = 0
    this.list()
  },
  mounted() {
    console.log('window.Jw.localerSe', window.JSON.parse(window.localStorage.getItem('customerServiceFatherTypeStorage') || 0))

    this.$nextTick(() => {
      this.getlocalStorage()
    })
  },
  methods: {
    getlocalStorage() {
      if (window.JSON.parse(window.localStorage.getItem('customerServiceFatherTypeStorage')) === 8) {
        console.log('112221', 'mounted----------------------------', this.textpalateid)
        const type = window.JSON.parse(window.localStorage.getItem('customerServiceTypeStorage') || '1')
        const res = window.JSON.parse(window.localStorage.getItem('customerServiceMassageStorage') || '{}')
        // eslint-disable-next-line eqeqeq
        if (type == '1') {
          if (Object.keys(res).length !== 0) {
            this.taskinput = res.taskinput
            this.textpalateid = res.textpalateid
            this.obj.content = res.obj
            this.addtifit = res.addtifit
            this.arr = res.arr
            this.addbiaoright = res.addbiaoright
            this.activeName = res.activeName
            this.formLabelAlign = res.formLabelAlign
            this.selectOffical = res.selectOffical
            this.temporary = res.temporary
            this.programimg = res.programimg
            this.emoji_icon = res.emoji_icon
          }
        }
      }
      // this.getlinktypesalllist()
    },
    gettype(type) {
      this.$nextTick(() => {
        this.storagetype = type
      })
    },
    deleteitem(index) {
      this.arr.splice(index, 1)
      this.indexinput = index - 1
      this.active = this.arr[index - 1].id
      if (this.textpalateid !== '') {
        this.getlinktypesalllist()
      }
    },
    handtipshow() {
      if (document.querySelector('.ciclebox')) { // 先判断下，不然会报错
        this.$nextTick(() => {
          this.arr.forEach(item => {
            item.showtips = false
          })
        })
      }
    },
    // 新增视频
    activeclick(id, index) {
      this.active = id
      this.indexinput = index
      this.arr.forEach(item => {
        item.showtips = false
      })
      this.arr[index].showtips = true
      if (this.textpalateid !== '') {
        this.getlinktypesalllist()
      }
    },
    // 新增图文
    addImageText() {
      this.arr.push({
        id: Math.random(),
        title: '标题',
        url: '',
        description: '',
        testsrc: '',
        showtips: false,
        switchvalue: 2, // 1开 2关
        app_ids: '', // 小程序
        app_path: '', // 链接
        moswitchvalue: 1// 1 默认 2 不默认
      })
      this.active = this.arr[this.arr.length - 1].id
      this.indexinput = this.arr.length - 1
      this.arr[this.indexinput].showtips = true
      if (this.textpalateid !== '') {
        this.getlinktypesalllist()
      }
    },
    // 获取链接类型
    async getlinktypesalllist() {
      const data = await getlinktypeslist({
        platform_id: this.textpalateid,
        mini_program: this.arr[this.indexinput].switchvalue
      })
      if (data.data !== null) {
        this.linkallarr = data.data
      } else {
        this.linkallarr = []
      }
      console.log('data', data.data)
    },
    beforehandleCommand() {
      if (this.textpalateid === '') {
        this.$message.error('请选择平台')
        return
      }
    },
    beforeHandleCommand(sign, identification) {
      return {
        'sign': sign,
        'identification': identification
      }
    },
    // 获取小程序消息类型
    async getmptypeslist() {
      this.programtype = []
      const data = await mptypeslist()
      this.programtype = data.data.types
      const mini_program = { index_path: '', mini_program_type: 99, type_name: '指定小程序' }
      this.programtype.push(mini_program)
      console.log('小程序类型', data.data.types)
    },
    // 获取光标所在位置的index
    handleInputBlur(e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    tiaoInputBlur(e) {
      this.tiaoblurIndex = e.srcElement.selectionStart
    },
    // 鼠标单击的事件
    onClick(e, editor) {
      console.log('Element clicked')
    },
    // 客服消息状态列表
    async customerlist() {
      const data = await customermessagelist()
      console.log('data', data.data.list)
      this.tabarr = data.data.list
    },
    // 获取客服消息标识
    async getcustomercation() {
      const data = await customerlogo({
        platformId: this.palateid
      })
      this.optionsr = data.data.list
      console.log('获取客服消息标识', data.data.list)
    },
    async getcustomercationtwo() {
      const data = await customerlogo({
        platformId: this.textpalateid
      })
      this.options = data.data.list
      console.log('获取客服消息标识', data.data.list)
    },
    // 获取七牛token
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },
    // 添加回调
    add() {
      if (this.taskinput === '') {
        this.$message.error('请输入消息标题')
        return
      }
      if (this.textpalateid === '') {
        this.$message.error('请选择平台')
        return
      }
      if (this.activeName === 'img') {
        if (this.temporary === null) {
          this.$message.error('请选择图片')
          return
        }
        this.msgData = {}
        this.msgData.img = {}
        this.msgData.img.media_id = this.keyid
        console.log(' this.msgData图片', this.msgData)
        this.saveclick(this.msgData)
        // this.temporary = null
        // this.keyid = null
      }
      if (this.activeName === 'text') {
        if (this.obj.content === '') {
          this.$message.error('请输入文本内容')
          return
        }
        this.msgData = {}
        this.msgData.text = {}
        this.msgData.text.content = this.obj.content
        console.log(' this.msgData文字', this.msgData)
        this.saveclick(this.msgData)
        // this.obj.content = ''
      }
      if (this.activeName === 'news') {
        // if (this.title === '') {
        //   this.$message.error('请输入标题')
        //   return
        // }
        // if (this.url === '') {
        //   this.$message.error('请输入链接')
        //   return
        // }
        // if (this.describetion === '') {
        //   this.$message.error('请输入描述')
        //   return
        // }
        // if (this.testsrc === '') {
        //   this.$message.error('请上传图片')
        //   return
        // }
        const bool = this.arr.every((item, index, array) => {
          return item.title !== ''
        })
        if (bool === false) {
          this.$message.error('请输入标题')
          return
        }
        // const booltwo = this.arr.every((item, index, array) => {
        //   return item.url !== '' && !item.switchvalue !==2
        // })
        // console.log('booltwo',booltwo)
        // if (booltwo === false) {
        //   this.$message.error('请输入链接')
        //   return
        // }
        for (let i = 0; i < this.arr.length; i++) {
          if (this.arr[i].switchvalue === 2) {
            // eslint-disable-next-line eqeqeq
            if (this.arr[i].url == '') {
              this.$message.error('请输入链接')
              return
            }
          }
          if (this.arr[i].switchvalue === 1) {
            // eslint-disable-next-line eqeqeq
            if (this.arr[i].app_ids == '' && this.arr[i].moswitchvalue == 2) {
              this.$message.error('请输入h5跳小程序appid')
              return
            }
            // eslint-disable-next-line eqeqeq
            if (this.startsWithWx(this.arr[i].app_ids) == false && this.arr[i].moswitchvalue == 2) {
              this.$message.error('请输入正确的h5跳小程序appid')
              return
            }
            // eslint-disable-next-line eqeqeq
            if (this.arr[i].app_path == '') {
              this.$message.error('请输入h5跳小程序地址')
              return
            }
          }
        }
        const boolthree = this.arr.every((item, index, array) => {
          return item.description !== ''
        })
        if (boolthree === false) {
          this.$message.error('请输入描述')
          return
        }
        const boolfour = this.arr.every((item, index, array) => {
          return item.testsrc !== ''
        })
        if (boolfour === false) {
          this.$message.error('请上传图片')
          return
        }
        this.msgData = {}
        this.msgData.news = {}
        this.msgData.news.articles = []
        this.arrsw = []
        this.arrsw = this.arr.map(item => { // item是数组中的每一个值
          return {
            description: item.description,
            title: item.title,
            url: item.url,
            picurl: item.testsrc,
            appid: item.app_ids,
            path: item.app_path,
            mini_program: item.switchvalue
          }
        })
        this.msgData.news.articles = this.arrsw
        // this.msgData.news.articles = this.arr
        // this.msgData.news.articles.title = this.title
        // this.msgData.news.articles.url = this.url
        // this.msgData.news.articles.description = this.describetion
        // this.msgData.news.articles.picurl = this.testsrc
        this.saveclick(this.msgData)
        this.title = ''
        this.url = ''
        this.describetion = ''
        this.testsrc = ''
        // console.log(' this.msgData图文', this.msgData)
      }

      // eslint-disable-next-line eqeqeq
      if (this.activeName == 'miniprogrampage') {
        console.log('小程序')
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.name == '') {
          this.$message.error('请输入标题')
          return
        }
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.sourceMaterialId == null) {
          this.$message.error('请上传图片')
          return
        }
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.appid == null) {
          this.$message.error('请选择小程序类型')
          return
        }
        if (this.formLabelAlign.appid === 99) {
          if (this.formLabelAlign.appid_Link === '') {
            this.$message.error('请输入指定小程序id')
            return
          }
        }
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.link == '') {
          this.$message.error('请输入跳转地址')
          return
        }
        this.msgData = {}
        this.msgData.miniprogrampage = {}
        this.msgData.miniprogrampage.title = this.formLabelAlign.name
        this.msgData.miniprogrampage.pagepath = this.formLabelAlign.link
        this.msgData.miniprogrampage.thumb_media_id = this.formLabelAlign.sourceMaterialId
        if (this.formLabelAlign.appid === 99) {
          this.msgData.miniprogrampage.appid = this.formLabelAlign.appid_Link
        } else {
          this.msgData.miniprogrampage.appid = this.formLabelAlign.appid
        }
        this.saveclick(this.msgData)
      }
      // eslint-disable-next-line eqeqeq
      if (this.activeName == 'miniprogram_official') {
        console.log('小程序')
        // eslint-disable-next-line eqeqeq
        if (this.selectOffical.length == 0) {
          this.$message.error('请选择一个官方小程序')
          return
        }
        this.msgData = {}
        this.msgData.miniprogram_official = {}
        this.msgData.miniprogram_official.app_id = this.selectOffical[0].app_id
        this.msgData.miniprogram_official.pagepath = this.selectOffical[0].pagepath
        this.msgData.miniprogram_official.source_material_id = this.selectOffical[0].source_material_id
        // this.msgData.miniprogram_official.source_material_id = this.selectOffical[0].source_material_id
        this.msgData.miniprogram_official.title = this.selectOffical[0].title
        this.msgData.miniprogram_official.weappiconurl = this.selectOffical[0].weappiconurl
        this.msgData.miniprogram_official.des_1 = this.selectOffical[0].des_1
        this.msgData.miniprogram_official.thumburl = this.selectOffical[0].thumburl
        this.msgData.miniprogram_official.sender_avatar = this.selectOffical[0].sender_avatar
        this.msgData.miniprogram_official.sender = this.selectOffical[0].sender
        this.msgData.miniprogram_official.type = this.selectOffical[0].type
        this.msgData.miniprogram_official.created_at = this.selectOffical[0].created_at
        this.msgData.miniprogram_official.miniprogram_no = this.selectOffical[0].miniprogram_no
        this.msgData.miniprogram_official.remark = this.selectOffical[0].remark
        this.saveclick(this.msgData)
      }
      this.messageload = true
    },
    startsWithWx(str) {
      // 使用正则表达式检查字符串是否以 "wx" 开头
      const regex = /^wx/
      return regex.test(str)
    },
    // 保存
    async saveclick(msgData) {
      // eslint-disable-next-line eqeqeq
      if (this.ontype == 3) {
        console.log('编辑接口')
        this.disabledsave = true
        try {
          const data = await customerMessageupdate({
            msg_type: this.activeName,
            title: this.taskinput,
            msg_data: msgData,
            platform_id: this.textpalateid,
            customer_message_no: this.customer_message_no
          })

          this.msgData = {}
          this.taskinput = ''
          console.log('data', data)
          if (data.code === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.$emit('creatsuccessclose')
            this.disabledsave = false
          }
        } catch (err) {
          this.disabledsave = false
        }
      } else {
        this.disabledsave = true
        try {
          const data = await customerservicecreat({
            msg_type: this.activeName,
            title: this.taskinput,
            msg_data: msgData,
            platform_id: this.textpalateid
          })
          this.msgData = {}
          this.taskinput = ''
          console.log('data', data)
          if (data.code === 200) {
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.$emit('creatsuccessclose')
            this.disabledsave = false
          }
        } catch (err) {
          this.disabledsave = false
        }
      }
    },
    // 上传图片回调 图片(不是裁剪上传)
    async uploadPictures(e) {
      console.log('e', e)
      const fileIfon = e.target.files[0]
      console.log('fileIfon', fileIfon)
      const img = new Image()
      const temporary = window.URL.createObjectURL(fileIfon)
      img.src = temporary
      const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
      console.log('ftype', ftype)
      const extension = ftype === '.jpg'
      const extension2 = ftype === '.png'
      const extension3 = ftype === '.jpeg'
      const extension4 = ftype === '.gif'
      // eslint-disable-next-line eqeqeq
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
          type: 'error'
        })
        return
      }
      console.log('ftype', ftype)
      // this.temporary = temporary
      const options = {
        quality: 0.62,
        noCompressIfLarger: false,
        maxWidth: 1000,
        maxHeight: 1000
      }
      if (ftype !== '.gif') {
        qiniu.compressImage(fileIfon, options).then(data => {
          const observable = qiniu.upload(data.dist, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
            fname: fileIfon.name // 文件名
          }, {
            useCdnDomain: true // cdn域名加速
          })
          observable.subscribe({
            next() { },
            error(err) {
              console.log(err)
            },
            complete: (data) => {
              console.log('上传图片data', data)
              newMaterial({
                type: 1,
                height: img.height,
                width: img.width,
                size: fileIfon.size,
                key: data.key
              }).then(response => {
                console.log('response', response)
                this.temporary = response.data.path
                this.keyid = response.data.sourceMaterialId
                this.$message({
                  message: '上传成功',
                  type: 'success'
                })
              })
            }
          })
        })
      } else {
        const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
          fname: fileIfon.name // 文件名
        }, {
          useCdnDomain: true // cdn域名加速
        })
        observable.subscribe({
          next() { },
          error(err) {
            console.log(err)
          },
          complete: (data) => {
            console.log('上传图片data', data)
            newMaterial({
              type: 1,
              height: img.height,
              width: img.width,
              size: fileIfon.size,
              key: data.key
            }).then(response => {
              console.log('response', response)
              this.temporary = response.data.path
              this.keyid = response.data.sourceMaterialId
              this.$message({
                message: '上传成功',
                type: 'success'
              })
            })
          }
        })
      }
    },

    // 上传按钮   限制图片大小 裁剪的上传 //file, fileList
    async changeUpload(e) {
      // const isLt5M = file.size / 1024 / 1024 < 5
      // if (!isLt5M) {
      //   this.$message.error('上传文件大小不能超过 5MB!')
      //   return false
      // }
      // const url = URL.createObjectURL(file.raw)
      // console.log('url', url)
      // this.fileinfo = file
      // console.log('file', file)
      // 上传成功后将图片地址赋值给裁剪框显示图片
      // this.$nextTick(() => {
      //   this.option.img = url
      //   this.dialogVisible = true
      // })
      const fileIfon = e.target.files[0]
      const img = new Image()
      const programimg = window.URL.createObjectURL(fileIfon)
      img.src = programimg
      // this.programimg = programimg
      const options = {
        quality: 0.62,
        noCompressIfLarger: false,
        maxWidth: 1000,
        maxHeight: 1000
      }
      const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
      const extension = ftype === '.jpg'
      const extension2 = ftype === '.png'
      const extension3 = ftype === '.jpeg'
      const extension4 = ftype === '.gif'
      // eslint-disable-next-line eqeqeq
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
          type: 'error'
        })
        return
      }
      if (ftype !== '.gif') {
        qiniu.compressImage(fileIfon, options).then(data => {
          const observable = qiniu.upload(data.dist, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
            fname: fileIfon.name // 文件名
          }, {
            useCdnDomain: true // cdn域名加速
          })
          observable.subscribe({
            next() { },
            error(err) {
              console.log(err)
            },
            complete: (data) => {
              newMaterial({
                type: 1,
                height: img.height,
                width: img.width,
                size: fileIfon.size,
                key: data.key
              }).then((res) => {
                console.log('res', res)
                this.arr[this.indexinput].testsrc = res.data.path
                // this.programimg = res.data.path
                // this.formLabelAlign.sourceMaterialId = res.data.sourceMaterialId
                this.$message({
                  message: '上传成功',
                  type: 'success'
                })
              })
            }
          })
        })
      } else {
        const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
          fname: fileIfon.name // 文件名
        }, {
          useCdnDomain: true // cdn域名加速
        })
        observable.subscribe({
          next() { },
          error(err) {
            console.log(err)
          },
          complete: (data) => {
            newMaterial({
              type: 1,
              height: img.height,
              width: img.width,
              size: fileIfon.size,
              key: data.key
            }).then((res) => {
              console.log('res', res)
              this.arr[this.indexinput].testsrc = res.data.path
              // this.programimg = res.data.path
              // this.formLabelAlign.sourceMaterialId = res.data.sourceMaterialId
              this.$message({
                message: '上传成功',
                type: 'success'
              })
            })
          }
        })
      }
    },
    // 截图成功上传图片
    finish() {
      this.$refs.cropper.getCropBlob((data) => {
        console.log('data', data)
        var sizebig = data.size
        const ftype = this.fileinfo.name.substr(this.fileinfo.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }
        const observable = qiniu.upload(data, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
          fname: this.fileinfo.name // 文件名
        }, {
          useCdnDomain: true // cdn域名加速
        })
        observable.subscribe({
          next() { },
          error(err) {
            console.log(err)
          },
          complete: (data) => {
            console.log('上传图片data', data)
            // this.key = data.key
            // this.testsrc = data.key
            newMaterial({
              type: 1,
              height: 201,
              width: 204,
              size: sizebig,
              key: data.key
            }).then(response => {
              console.log('response', response)
              this.arr[this.indexinput].testsrc = response.data.path
              // this.testsrc = response.data.path
              this.keyid = response.data.sourceMaterialId
              this.$message({
                message: '上传成功',
                type: 'success'
              })
            })
            this.dialogVisible = false
          }
        })
      })
    },
    // 点击表情回调
    itemclaickw(idx) {
      // this.obj.content += this.emoji_icon[idx]
      this.obj.content = this.obj.content.slice(0, this.blurIndex) + this.emoji_icon[idx] + this.obj.content.slice(this.blurIndex)
    },
    // 选择超链接回调
    linkbtn(linkobj) {
      this.obj.content = this.obj.content.slice(0, this.blurIndex) + `<a href="${linkobj.linkwritten}">${linkobj.written}</a>` + this.obj.content.slice(this.blurIndex)
      this.linkdialogVisible = false
    },
    // 选择关键词回调
    keywordbtn(keywordobj) {
      // this.obj.content += `<a href="weixin://bizmsgmenu?msgmenuid=1&msgmenucontent=${keywordobj.keywordwritten}">${keywordobj.keywordtext}</a>`
      this.obj.content = this.obj.content.slice(0, this.blurIndex) + `<a href="weixin://bizmsgmenu?msgmenuid=1&msgmenucontent=${keywordobj.keywordwritten}">${keywordobj.keywordtext}</a>` + this.obj.content.slice(this.blurIndex)
      this.keyworddialogVisible = false
    },
    // 选择标志回调
    addidentifit() {
      if (this.addtifit === '') {
        this.$message.error('请选择标志')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.addtifit == '${activity_}') {
        console.log('this.addtifit书城活动', this.addtifit)
        this.bookctyactivitiesVisible = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.bookctyactivitiesbox.send(this.textpalateid, 1)
        }, 100)
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.addtifit == '${red_pack_}') {
        console.log('this.addtifit红包活动', this.addtifit)
        this.redbao = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.chooseredbao.send(this.textpalateid, 1)
        }, 100)
        return
      }

      this.obj.content = this.obj.content.slice(0, this.blurIndex) + this.addtifit + this.obj.content.slice(this.blurIndex)
      // this.obj.content += this.addtifit
    },
    // 选择书城活动回调
    callbadwr(item, type) {
      this.bookctyactivitiesVisible = false
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        this.obj.content = this.obj.content.slice(0, this.blurIndex) + item.sign + this.obj.content.slice(this.blurIndex)
      }
      // eslint-disable-next-line eqeqeq
      if (type == 2) {
        if (this.arr[this.indexinput].switchvalue === 2) {
          this.arr[this.indexinput].url = ''
          this.arr[this.indexinput].url = item.sign
        } else {
          this.arr[this.indexinput].app_path = ''
          this.arr[this.indexinput].app_path = item.sign
        }

        // this.url = ''
        // this.url = this.url.slice(0, this.tiaoblurIndex) + item.sign + this.url.slice(this.tiaoblurIndex)
      }
    },
    // 选择红包活动回调
    redcallback(item, type) {
      this.redbao = false
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        this.obj.content = this.obj.content.slice(0, this.blurIndex) + item.sign + this.obj.content.slice(this.blurIndex)
      }
      // eslint-disable-next-line eqeqeq
      if (type == 2) {
        if (this.arr[this.indexinput].switchvalue === 2) {
          this.arr[this.indexinput].url = ''
          this.arr[this.indexinput].url = item.sign
        } else {
          this.arr[this.indexinput].app_path = ''
          this.arr[this.indexinput].app_path = item.sign
        }
        // this.url = ''
        // this.url = this.url.slice(0, this.tiaoblurIndex) + item.sign + this.url.slice(this.tiaoblurIndex)
      }
    },
    clickicon(img, key) {
      console.log(img, key)
      if (this.activeName === 'img') {
        this.temporary = img
        this.keyid = key
      }
      if (this.activeName === 'news') {
        this.arr[this.indexinput].testsrc = img
        // this.testsrc = img
      }
      if (this.activeName === 'miniprogrampage') {
        this.formLabelAlign.sourceMaterialId = key
        this.programimg = img
      }
      // temporary: null, // 上传图片显示(不是图文图片)
      // keyid: null, // 上传图片成功的key 不是图文 是图片消息
      // this.testsrc = img
      this.dialogVisibletwo = false
    },
    materiallibrary() {
      this.dialogVisibletwo = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },

    // 处理富文本的东西
    async  opens(dialogTableVisible, type) {
      await this.getlocalStorage()
      this.showtinymce = dialogTableVisible
      console.log('222', dialogTableVisible, type)
      if (this.textpalateid !== '') {
        this.getlinktypesalllist()
      }
    },
    close(dialogTableVisible) {
      console.log('111', dialogTableVisible)
      this.showtinymce = dialogTableVisible
    },
    addwebpagebox() {
      if (this.addbiaoright === null) {
        this.$message.error('请选择标志')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.addbiaoright == '${activity_}') {
        this.bookctyactivitiesVisible = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.bookctyactivitiesbox.send(this.textpalateid, 2)
        }, 100)
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.addbiaoright == '${red_pack_}') {
        this.redbao = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.chooseredbao.send(this.textpalateid, 2)
        }, 100)
        return
      }
      console.log('6666')
      // this.title = this.title.slice(0, this.tiaoblurIndex) + this.addbiaoright + this.title.slice(this.tiaoblurIndex)
      // this.arr[this.indexinput].title
      this.arr[this.indexinput].title = this.arr[this.indexinput].title.slice(0, this.tiaoblurIndex) + this.addbiaoright + this.arr[this.indexinput].title.slice(this.tiaoblurIndex)
    },
    changepalate() {
      this.optionsr = []
      this.addbiaoright = null
      this.getcustomercation()
    },
    changetextpalate() {
      this.options = []
      this.addtifit = ''
      this.addbiaoright = null
      this.getcustomercationtwo()
      // this.obj.content = ''
      this.url = ''
      this.getlinktypesalllist()
      this.arr.forEach((item) => {
        // item.title = '标题'
        item.url = ''
        item.app_path = ''
      })
    },
    chooseactivity() {
      this.activitydialogVisible = true
      this.$nextTick(() => {
        this.$refs.activitybox.send(this.textpalateid)
      })
    },
    activityclose(item) {
      this.activitydialogVisible = false
      this.activityidname = item.activityName
      this.activityid = item.id
    },
    async uploadPicturesr(e) {
      const fileIfon = e.target.files[0]
      const img = new Image()
      const programimg = window.URL.createObjectURL(fileIfon)
      img.src = programimg
      // this.programimg = programimg
      console.log('小程序')
      const options = {
        quality: 0.62,
        noCompressIfLarger: false,
        maxWidth: 1000,
        maxHeight: 1000
      }
      const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
      const extension = ftype === '.jpg'
      const extension2 = ftype === '.png'
      const extension3 = ftype === '.jpeg'
      const extension4 = ftype === '.gif'
      // eslint-disable-next-line eqeqeq
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
          type: 'error'
        })
        return
      }
      if (ftype !== '.gif') {
        qiniu.compressImage(fileIfon, options).then(data => {
          const observable = qiniu.upload(data.dist, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
            fname: fileIfon.name // 文件名
          }, {
            useCdnDomain: true // cdn域名加速
          })
          observable.subscribe({
            next() { },
            error(err) {
              console.log(err)
            },
            complete: (data) => {
              newMaterial({
                type: 1,
                height: img.height,
                width: img.width,
                size: fileIfon.size,
                key: data.key
              }).then((res) => {
                console.log('res', res)
                this.programimg = res.data.path
                this.formLabelAlign.sourceMaterialId = res.data.sourceMaterialId
                this.$message({
                  message: '上传成功',
                  type: 'success'
                })
              })
            }
          })
        })
      } else {
        const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
          fname: fileIfon.name // 文件名
        }, {
          useCdnDomain: true // cdn域名加速
        })
        observable.subscribe({
          next() { },
          error(err) {
            console.log(err)
          },
          complete: (data) => {
            newMaterial({
              type: 1,
              height: img.height,
              width: img.width,
              size: fileIfon.size,
              key: data.key
            }).then((res) => {
              console.log('res', res)
              this.programimg = res.data.path
              this.formLabelAlign.sourceMaterialId = res.data.sourceMaterialId
              this.$message({
                message: '上传成功',
                type: 'success'
              })
            })
          }
        })
      }
    },
    chawer(val) {
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      const index = this.programtype.findIndex(v => v.mini_program_type == val)
      this.formLabelAlign.link = this.programtype[index].index_path
    },
    linkclick() {
      if (this.textpalateid === '') {
        this.$message.error('请选择平台')
        return
      }
      this.linkdialogVisible = true
      this.$nextTick(() => {
        this.$refs.linkdialog.linksend(this.textpalateid)
      })
    },
    appletclick() {
      this.applets = true
      this.$nextTick(() => {
        this.$refs.appletsview.send()
      })
    },
    handleCommand(command) {
      if (this.textpalateid === '') {
        this.$message.error('请选择平台')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (command.identification == 'platform_activity') {
        this.bookctyactivitiesVisible = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.bookctyactivitiesbox.send(this.textpalateid, 2)
        }, 100)
      }
      // eslint-disable-next-line eqeqeq
      if (command.identification == 'red_packet_activity') {
        this.redbao = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.chooseredbao.send(this.textpalateid, 2)
        }, 100)
      }
      // eslint-disable-next-line eqeqeq
      if (command.identification == 'platform_promotion_link') {
        this.sclink = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.sclinkview.send(this.textpalateid, this.arr[this.indexinput].switchvalue)
        }, 100)
      }
      // eslint-disable-next-line eqeqeq
      if (command.identification == '') {
        if (this.arr[this.indexinput].switchvalue === 2) {
          this.arr[this.indexinput].url = ''
          this.arr[this.indexinput].url = command.sign
        } else {
          this.arr[this.indexinput].app_path = ''
          this.arr[this.indexinput].app_path = command.sign
        }

        // this.url = ''
        // this.url = command.sign
      }
    },
    sclinkcallback(item) {
      this.sclink = false
      // this.url = ''
      // this.url = this.url.slice(0, this.tiaoblurIndex) + item.sign_template_no + this.url.slice(this.tiaoblurIndex)
      // this.arr[this.indexinput].url = ''
      // this.arr[this.indexinput].url = item.sign_template_no

      if (this.arr[this.indexinput].switchvalue === 2) {
        this.arr[this.indexinput].url = ''
        this.arr[this.indexinput].url = item.sign_template_no
      } else {
        this.arr[this.indexinput].app_path = ''
        this.arr[this.indexinput].app_path = item.sign_template_no
      }
    },
    appletscallback(item) {
      this.applets = false
      if (item.formLabeltype === 9999) {
        this.obj.content = this.obj.content.slice(0, this.blurIndex) + `<a data-miniprogram-appid="${item.appid}"  data-miniprogram-path="${item.link}">${item.title}</a>` + this.obj.content.slice(this.blurIndex)
      } else {
        this.obj.content = this.obj.content.slice(0, this.blurIndex) + `<a data-miniprogram-appid="${item.formLabeltype}"  data-miniprogram-path="${item.link}">${item.title}</a>` + this.obj.content.slice(this.blurIndex)
      }
    },
    edit(item, type) {
      console.log('编辑', item, type)
      this.textpalateid = item.platform_id
      // 复用
      // eslint-disable-next-line eqeqeq
      if (type == 2) {
        this.taskinput = item.title + '-复用'
        this.ontype = type
      }
      // 编辑
      // eslint-disable-next-line eqeqeq
      if (type == 3) {
        this.taskinput = item.title
        this.customer_message_no = item.customer_message_no
        this.ontype = type
      }

      this.activeName = item.msg_type
      this.getcustomercationtwo()// 获取标志列表 文本类型调用
      if (item.msg_type === 'miniprogrampage') {
        this.formLabelAlign.name = item.msg_data.miniprogrampage.title
        this.programimg = item.msg_data.miniprogrampage.thumb_media_url
        this.formLabelAlign.sourceMaterialId = item.msg_data.miniprogrampage.thumb_media_id
        this.formLabelAlign.appid = item.msg_data.miniprogrampage.appid
        this.formLabelAlign.link = item.msg_data.miniprogrampage.pagepath
        if (item.msg_data.miniprogrampage.appid_type === 0) {
          this.formLabelAlign.appid = 99
          this.formLabelAlign.appid_Link = item.msg_data.miniprogrampage.appid
        }
        console.log('小程序')
      }
      if (item.msg_type === 'text') {
        console.log('文本')
        this.obj.content = item.msg_data.text.content
      }
      if (item.msg_type === 'img') {
        console.log('图片')
        this.keyid = item.msg_data.img.media_id
        this.temporary = item.msg_data.img.url
      }
      if (item.msg_type === 'news') {
        console.log('图文链接', item.msg_data.news.articles)
        this.arr = []
        this.arr = item.msg_data.news.articles.map(item => { // item是数组中的每一个值
          return {
            id: Math.random(),
            description: item.description,
            title: item.title,
            // url: item.url,
            url: item.url == null ? '' : item.url,
            testsrc: item.picurl,
            showtips: false,
            switchvalue: item.mini_program,
            app_ids: item.appid,
            app_path: item.path,
            moswitchvalue: item.appid === '' ? 1 : 2
          }
        })
        this.active = this.arr[0].id
        this.indexinput = 0
      }
      if (item.msg_type === 'miniprogram_official') {
        console.log('我是官方小程序')
        this.selectOffical.push(item.msg_data.miniprogram_official)
      }
      this.getlinktypesalllist()// 获取链接活动 图文链接调用
    },
    // 官方小程序列表
    async list() {
      const data = await miniprogramList(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('miniprogramList data', this.tableData)
    },
    // 选择的官方小程序
    select(item, index) {
      this.selectOffical = []
      this.selectOffical.push(item)
      console.log('index----', index, item)
      console.log('selectOffical', this.selectOffical)
    },
    errorHandler() {
      return true
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    chooseofficial() {
      this.officialapplets = true
      this.$nextTick(() => {
        this.$refs.chooseminofficialview.send()
      })
    },
    chooseminofficialcallback(item) {
      this.officialapplets = false
      console.log(item)
      this.selectOffical = []
      this.selectOffical.push(item)
    },
    removeAllSpaces() {
      // 去掉输入值中的所有空格
      this.arr[this.indexinput].app_ids = this.arr[this.indexinput].app_ids.replace(/\s+/g, '')
    },
    removeAllSpacestwo() {
      this.arr[this.indexinput].app_path = this.arr[this.indexinput].app_path.replace(/\s+/g, '')
    },
    htiaower(val) {
      console.log('val', val)
      if (val === 1) {
        this.arr[this.indexinput].url = ''
        if (this.textpalateid !== '') {
          this.getlinktypesalllist()
        }
      } else {
        this.arr[this.indexinput].app_ids = ''
        this.arr[this.indexinput].app_path = ''
        if (this.textpalateid !== '') {
          this.getlinktypesalllist()
        }
      }
    },
    mochange(val) {
      if (val === 1) {
        this.arr[this.indexinput].app_ids = ''
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.task_box{
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.updata_box{
  width: 708px;
  border: 1px solid #dddee1;
  padding: 10px;
  margin-bottom: 10px;
}
.pic_img{
  width: 100px;
  height: 100px;
  padding: 10px;
}
.pic_box{
  width: 238px;
  border: 1px solid #ccc;
  position: relative;
}
.writtenwords{
  /* padding: 20px; */
  white-space: pre-line;
}
.imaetext{
  display: flex;
  justify-content: space-between;
}
.imagetext{
  padding: 10px;
}
.newview{
  padding: 10px;
  max-height: 340px;
  overflow: hidden;
  overflow-y: auto;
}
.newview::-webkit-scrollbar {
  display: none;
}
.image_title{
  margin-bottom: 20px;
}
.tab_box{
  width: 880px;
  border: 1px solid #dddee1;
  padding: 5px 24px 52px 15px;
  margin-top: 20px;
}
.add_boxr{
  width: 708px;
  border: 1px dashed #999999;
  padding: 5px 0px;
  text-align: center;
  margin-top: 15px;
}
.examples_leftbox{
  width: 258px;
  height: 126px;
  border: 1px solid #dddee1;
  padding: 5px 10px;
  position: relative;
}
.examples_leftboxtelrp{
  width: 202px;
  height: 123px;
  border: 1px solid #dddee1;
  padding: 5px 10px;
  position: relative;
}
.addwr{
  position: absolute;
  bottom: -30px;
  left: 80px;
}
.within_box{
  border: 1px solid #19be6b;
  height: 100%;
  padding: 8px 8px 8px 7px;
}
.se_top{
  margin-top: 14px;
}
.describe_text{
  color: #999999;
  width: 136px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  height: 50px;
}
.input_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.allexamples_box{
  display: flex;
  margin-top: 20px;
}
.examples_rightbox{
  margin-left: 30px;
}
.cover_box{
  display: flex;
  align-items: center;
}
.choose_cover{
  margin-left: 10px;
  margin-right: 10px;
}
.cropper-content .cropper {
        width: auto;
        height: 300px;
}
.upload-demo /deep/ .el-upload-dragger{
      width: auto;
      height: auto;
      border: none;
}
.uopatatextimg{
  width: 100px;
  height: 100px;
  margin-top: 20px;
  object-fit: contain;
}
.choosecover{
  display: flex;
  align-items: center;
}
.text_wei {
  flex-shrink: 0;
}
.chooseitem{
  margin-bottom: 30px;
}
.save_box{
  margin-top: 10px;
}
.choose_textr{
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.link_url{
   margin: 0 10px;
}
.btn_determine{
  margin-top: 30px;
  text-align: right;
}
.tips_mask{
  position: absolute;
  top: 0;
  opacity: 0.5;
  background: #000000;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 55px;
  justify-content: space-around;
}
.tipicon{
  font-size: 19px;
  color:black
}
.add_name{
  /* margin: 10px 0px 0px 0px; */
  margin-right: 10px;
}
.phone_box{
  background: url('https://mp.2f.com/v2.7.2/img/iphone6.395625b9.jpg') no-repeat;
  background-size: 100% 100%;
  width: 300px;
  height: 600px;
  margin-left: 100px;
  position: relative;
}
.phone_content{
  width: 224px;
  background: #ffffff;
  position: absolute;
  top: 135px;
  left: 30px;
  padding: 10px 25px 14px 11px;
  box-sizing: border-box;
}
.phone_contentone{
  width: 224px;
  background: #ffffff;
  position: absolute;
  top: 135px;
  left: 30px;
}
.phone_data{
  color: #d1dfff;
  margin-top: 10px;
  margin-bottom: 10px;
}
.phone_item{
  margin-bottom: 10px;
}
.add_template{
  display: flex;
}
.choose_plate{
  display: flex;
  align-items: center;
}
.li_img{
  width: 100px;
  height: 100px;
}
.updataactive{
   border: 2px solid #07c160 !important;
}
.updatabox{
  height: 100px;
  width: 220px;
  text-align: center;
  line-height: 100px;
  border: 1px solid #f3f3f3;
  position: relative;
}
.updatabox1{
    position: relative;
    height: 72px;
      width: 220px;
    border: 1px solid #f3f3f3;
    padding: 0 27px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.spanbox{
  position: absolute;
  left: 15px;
  top: 30px;
  z-index: 9;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 187px;
  text-align: left;
  height: 60px;
}
.spanbox1{
    position: inherit;
    left: 0;
    top: 0;
    z-index: 9;
    width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.backrbox{
width: auto;
    height: 100%;
  background-color: #e1e1e1;
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.backrbox1{
    position: absolute;
    background-color: #e1e1e1;
        background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    top: 9px;
    right: 17px;
    width: 50px;
    height: 50px;
}
.addbox{
  width: 220px;
  height: 48px;
  border: 1px solid #f3f3f3;
  text-align: center;
  line-height: 48px;
  position: relative;
}
.tipbox{
  position: absolute;
  background: white;
  padding: 10px;
  position: absolute;
  top: 39px;
  left: 180px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 20px;
  height: 20px;
}
.ciclebox{
  /* padding: 15px 7px 5px 7px; */
  margin: 0 7px;
  background-color: #fff;
  box-shadow: 0 1px 6px 0 #e4e8eb;
  border-radius: 25px;
  position: absolute;
  left: 220px;
  top: 50%;
  transform: translate(0, -50%);
}
.tiparrowbox{
  display: flex;
  flex-direction: column;
}
.title_box{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 187px;
}
.title_boxr{

  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  height: 30px;
    width: 217px;
    overflow: hidden;
}
.chooser_allbox{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-height: 600px;
  overflow-y: auto;
}
.chooser_box{
  width: 250px;
  height: 430px;
  border: 1px solid #e9e9e9;
  padding: 12px;
  box-sizing: border-box;
  /* margin: 0 auto; */
  margin-bottom: 20px;
  margin-right: 30px;
}
.titlew_box{
  margin-left: 5px;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cahrw_box{
  margin-top: 10px;
}
.line{
  height: 1px;
  background-color: #e9e9e9;
  width: 100%;
  margin-top: 8px;
}
.daser{
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 227px;
  margin-top:5px;
  height: 37px;
}
.copy_box{
  display: flex;
  align-items: center;
}
.copy_icon{
  margin-left: 5px;
}
.Pchooser_allbox{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-height: 400px;
  overflow-y: auto;
}
.Pchooser_box{
  width: 100%;
  height: 75%;
  box-sizing: border-box;
  margin-right: 30px;
}
.Ptitlew_box{
  margin-left: 5px;
  /* width: 150px; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Pcahrw_box{
  /* margin-top: 10px; */
}
.Pline{
  height: 1px;
  background-color: #e9e9e9;
  width: 100%;
  margin-top: 8px;
}
.Pdaser{
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 227px; */
  margin-top:5px;
  max-height: 35px;
  margin-bottom: 5px;
}
.Pdaserr{
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
  margin-top:5px;
  max-height: 35px;
  margin-bottom: 5px;
}
.Pcopy_box{
  display: flex;
  align-items: center;
}
.Pcopy_icon{
  margin-left: 5px;
}
.serwerwe{
  border: 1px solid #ccc;
  padding: 15px;
  margin-top: 10px;
}
</style>
